"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.watchSubmitLeadSurveyWorker = watchSubmitLeadSurveyWorker;
exports.default = watchSubmitLeadSurvey;
const js_1 = __importDefault(require("@bugsnag/js"));
const effects_1 = require("redux-saga/effects");
const leadSurvey_1 = require("../../../slices/leadSurvey");
const completeLeadSurvey_1 = __importDefault(require("./fetchers/completeLeadSurvey"));
function* watchSubmitLeadSurveyWorker() {
    try {
        const state = yield (0, effects_1.select)((state) => {
            return {
                leadSurveyId: state.leadSurvey.leadSurveyId,
                group: state.leadSurvey.group,
                questionsResponses: state.leadSurvey.questionsResponses
            };
        });
        if (!state.group) {
            js_1.default.notify({
                name: state.leadSurveyId,
                message: 'Group does not exist'
            });
            return;
        }
        for (const question of state.group.questions) {
            const answer = state.questionsResponses[question.id];
            if (question.is_mandatory && (!answer || answer.responses.length < 1)) {
                yield (0, effects_1.put)((0, leadSurvey_1.setQuestionError)(question.id));
                return;
            }
        }
        const response = yield (0, effects_1.call)(completeLeadSurvey_1.default, {
            leadSurveyId: state.leadSurveyId,
            groupId: state.group.id
        });
        if (response.unansweredQuestionIds.length > 0) {
            for (const unansweredQuestionId of response.unansweredQuestionIds) {
                yield (0, effects_1.put)((0, leadSurvey_1.setQuestionError)(unansweredQuestionId));
            }
        }
        else if (!response.isLeadSurveyCompleted) {
            yield (0, effects_1.put)((0, leadSurvey_1.loadLeadSurvey)({
                leadSurveyId: state.leadSurveyId
            }));
        }
        else {
            yield (0, effects_1.put)((0, leadSurvey_1.submitLeadSurveySuccess)({
                isLeadSurveyCompleted: response.isLeadSurveyCompleted,
                projectId: response.projectId,
                terrainId: response.terrainId,
                sellerName: response.sellerName,
                email: response.email
            }));
        }
    }
    catch (error) {
        js_1.default.notify(error);
        yield (0, effects_1.put)((0, leadSurvey_1.submitLeadSurveyFailure)('errors:unknownError'));
    }
}
function* watchSubmitLeadSurvey() {
    yield (0, effects_1.takeLatest)(leadSurvey_1.submitLeadSurvey, watchSubmitLeadSurveyWorker);
}
//# sourceMappingURL=index.js.map